import { api } from './client';

export type CRUDPermission = 'create' | 'read' | 'update' | 'delete';

export interface PermissionsResponse {
  permissions: Record<string, CRUDPermission[]>;
}

export const permissionsApi = {
  // Get UI permissions for a group
  getGroupPermissions: async (groupId: string): Promise<Record<string, CRUDPermission[]>> => {
    const response = await api.get(`/groups/${groupId}/ui-permissions`);
    return response.data?.data?.permissions || {};
  },

  // Set UI permissions for a group
  setGroupPermissions: async (groupId: string, permissions: Record<string, CRUDPermission[]>): Promise<void> => {
    await api.put(`/groups/${groupId}/ui-permissions`, { permissions });
  },

  // Get merged UI permissions for current user
  getUserPermissions: async (userId: string): Promise<Record<string, CRUDPermission[]>> => {
    const response = await api.get(`/users/${userId}/ui-permissions`);
    return response.data?.data?.permissions || {};
  },

  // Get my merged permissions
  getMyPermissions: async (): Promise<Record<string, CRUDPermission[]>> => {
    const response = await api.get('/auth/me');
    const userId = response.data?.data?.id;
    if (!userId) return {};
    return permissionsApi.getUserPermissions(userId);
  },
};

export default permissionsApi;
